var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (icon) { 
__p+='\n  <i class="icon icon--'+
((__t=(icon))==null?'':_.escape(__t))+
' icon--auto-width"></i>\n';
 } 
__p+='\n<span class="text"></span>\n<span class="loader"></span>\n';
}
return __p;
};
